import Layout from "../include/layout";
import { Button, Form, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import CustomAddModal from "../../components/CustomAddModal";
import CustomEditModal from "../../components/CustomEditModal";
import Filarial from "../include/filarial";
import Joi from "joi-browser";
import ApprenantsService from "./ApprenantsService";
import InscriptionsService from "../inscriptions/InscriptionsService";
import UsersService from "../users/UsersService";
import ClassesService from "../classe/ClassesService";
import ClassesoptionsService from "../classesoptions/ClassesoptionsService";
import { setIn } from "formik";
import PersonnesService from "../personnes/PersonnesService";

export default function ApprenantsIndex() {
    const activeLink = "APPRENANTS"

    const token = useSelector(state => state.auth.token)
    const [apprenants, setApprenants] = useState([])
    const [isVisible, setIsVisible] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [personnes, setPersonnes] = useState(false);
    const [selectedClasseOption, setSelectedClasseOption] = useState(null)
    const [selectedClasse, setSelectedClasse] = useState(null)
    //const [classesoptions, setclasseOptions] = useState(false);
    const [classeoptions, setClasseOptions] = useState([])
    const [classes, setClasses] = useState(false);
    const [inscriptions, setIncriptions] = useState(false);
    const [errors, setErrors] = useState({});
    //const [selectedClasseId, setSelectedClasseId] = useState(null);
    //const [filteredClasseOptions, setFilteredClasseOptions] = useState([]);

    const [selectedPersonne, setSelectedPersonne] = useState({ nom: '', prenoms: '' });
    const [selectedInscrit, setSelectedInscrit] = useState({ nom: '', prenoms: '' });
    //declaration des variables pour le form d'edition
    const [editFormData, setEditFormData] = useState({
        matriculeApprenant: '',
        personneId: '',
        inscriptionId: '',
        classeId: '',
        classeoptionId: '',
        id: ''
    });

    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)


    //GESTION DES REGLES POUR LES FORMULAIRES D'EDITION
    const schemaEditData = {
        id: Joi.number().min(1).empty('').options({
            language: {
                number: { min: "minimum 1" },
            },
        }).label("Id"),

        matriculeApprenant: Joi.string().min(2).max(100).required().empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("Matricule"),

        personneId: Joi.number().integer().required().empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                number: { min: "minimum 2 caractères", integer: 'Doit être un nombre entier' },
            },
        }).label("Personne"),

        classeId: Joi.number().integer().required().empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                number: { min: "minimum 2 caractères", integer: 'Doit être un nombre entier' },
            },
        }).label("Classe"),

        classeoptionId: Joi.number().integer().min(1).required().empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { number: 'vous devez renseignez un nombre' },
            },
        }).label("Option"),

        inscriptionId: Joi.number().required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
            },
        }).label("Inscription"),
    };

    //get liste personnes
    const fetchPersonnes = async () => {
        try {
            const res = await PersonnesService.index(token);
            //console.log('personnes:', res.data.data.personnes);
            setPersonnes(res.data.data.personnes);
        } catch (error) {
            console.error('Erreur de récupération des personnes:', error);
        }
    }

    //get liste classes
    /*const fetchClasses = async () => {
        await ClassesService.index(token).then((res) => {
            //console.log('classes:', res.data.data.classes)
            setClasses(res.data.data.classes)
        }).catch(error => {
            console.log(error)
        })
    }*/

    
    //get liste classes
    /*const fetchOptions = async () => {
        await ClassesoptionsService.index(token).then((res) => {
            console.log('options:', res.data.data.classesoptions)
            setclasseOptions(res.data.data.classesoptions)
        }).catch(error => {
            console.log(error)
        })
    }*/

    //get liste inscriptions
    const fetchInscrits = async () => {
        await InscriptionsService.index(token).then((res) => {
            //console.log('inscriptioon:', res.data.data.inscriptions)
            setIncriptions(res.data.data.inscriptions)
        }).catch(error => {
            console.log(error)
        })
    }



    //get liste apprenants
    const fetchApprenants = async () => {
        await ApprenantsService.index(token).then((res) => {
            //console.log('apprenants', res.data.data.apprenants)
            setApprenants(res.data.data.apprenants)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                ApprenantsService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchApprenants()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }

    ///Lancer le modal d'edition
    const lauchEdit = async (id) => {
        await ApprenantsService.show(id, token).then((response) => {
            const data = response.data.data;
            //console.log('show', response.data.data)
            //console.log('personnes', data.personnes.nomPersonne);
            setEditFormData({
                matriculeApprenant: data.matriculeApprenant || '',
                personneId: data.personnes?.id || data.personnes?.personnes?.id || '',
                inscriptionId: data.inscriptions?.id || '',
                classeId: data.classes?.id || data.classesoptions?.classes?.id || '',
                classeoptionId: data.classesoptions?.id || '',
                id: data.id || ''
            })
            setEditModal(true)

            setSelectedPersonne({
                nom: data.personnes.nomPersonne,
                prenoms: data.personnes.prenomsPersonne
            });
            setSelectedInscrit({
                code_recu: data.inscriptions.coderecuInscription
            })
        }).catch((error) => {
            Swal.fire({
                icon: "error",
                text: error.message,
            });
        });
    }

    //Vérifie si la règle de validation est validé ou pas
    const validateEditProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaEditData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    const handleEditChange = async (e) => {
        let _data = { ...editFormData };
        _data['classeId'] = e.code;
        _data['classeoptionId'] = '';
        setEditFormData(_data);
        setSelectedClasse(e); 
        setClasseOptions([]);
        await fetchClassesoptions(e.code);
        setSelectedClasseOption(null);
    };
    
    // Fonction appelée lors du changement de classe option
    const onChangeClasseOption = (e) => {
        let _data = { ...editFormData };
        _data['classeoptionId'] = e.code;
        setEditFormData(_data);
        setSelectedClasseOption(e); 
    };

    // récupération de la liste des classes pour l'édition
    const fetchClasses = async () => {
        await ClassesService.index(token).then(({ data }) => {
            if (data.data.classes.length > 0) {
                const optionClasse = data.data.classes.map((option) => ({
                    name: option.libelleClasse,
                    code: option.id
                }));
                setClasses(optionClasse);
            }
        }).catch(({ response }) => {
            console.log(response);
        });
    };
    
    // récupérer les options de classe selon le code de la classe sélectionnée
    const fetchClassesoptions = async (id) => {
        await ClassesoptionsService.getOptionByClasse(id, token).then((res) => {
            if (res.data.data.length > 0) {
                const options = res.data.data.map((option) => ({
                    code: option.id,
                    name: option.libelleClasseOption
                }));
                setClasseOptions(options);
            } else {
                setClasseOptions([]);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    /*const handleEditChange = (event) => {
        const { name, value } = event.target;
    
        setEditFormData({
            ...editFormData,
            [name]: value
        });
    };*/

    //update fonction
    const handleUpdate = async (event) => {
        event.preventDefault();

        // Validation des données
        const result = Joi.validate(editFormData, schemaEditData, { abortEarly: false });
        const { error } = result;

        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            setErrors(errorData);
            return;
        } else {
            try {
                const response = await ApprenantsService.update(editFormData, token);

                // Fermer le modal après la mise à jour
                setEditModal(false);

                // Vérifier le statut de la réponse
                if (response.data && response.data.status === 200) {
                    // Mise à jour réussie, rafraîchir la liste des apprenants
                    fetchApprenants();

                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        showConfirmButton: false,
                        timer: 3000,
                    });
                } else {
                    // Gestion des erreurs
                    Swal.fire({
                        icon: "error",
                        text: response.data ? response.data.message : "Erreur inconnue",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                }
            } catch (error) {
                // Fermer le modal en cas d'erreur
                setEditModal(false);

                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
            }
        }
    };


    ///Content du modal d'edition de matière
    const editModalContent = (
        <Form className="needs-validation" noValidate onSubmit={handleUpdate}>
            <div className="row">
                {/* Matricule Apprenant */}
                <div className="col-md-6 mb-3">
                    <Form.Label className="form-label fw-bold" htmlFor="bs-validation-matriculeApprenant">
                        Matricule Apprenant <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Control
                        className="form-control"
                        id="bs-validation-matriculeApprenant"
                        type="text"
                        value={editFormData.matriculeApprenant}
                        onChange={handleEditChange}
                        required={true}
                        name="matriculeApprenant"
                        disabled
                    />


                    {errors.matriculeApprenant && (
                        <div className="alert alert-danger">{errors.matriculeApprenant}</div>
                    )}
                </div>

                {/* Sélection de la Personne */}
                <div className="col-md-6 mb-3">
                    <Form.Label className="form-label fw-bold" htmlFor="bs-validation-personneId">
                        Personne <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Select
                        className="select2 form-select form-select-md"
                        name="personneId"
                        id="bs-validation-personneId"
                        value={editFormData.personneId} // Utilisez l'ID de la personne dans les données du formulaire
                        disabled // Champ désactivé
                    >
                        <option value="">
                            {selectedPersonne.nom} {selectedPersonne.prenoms} {/* Affichez le nom et le prénom */}
                        </option>
                    </Form.Select>


                    {errors.personneId && (
                        <div className="alert alert-danger">{errors.personneId}</div>
                    )}
                </div>

                {/* Sélection de la Classe */}
                <div className="col-md-6 mb-3">
                    <Form.Label className="form-label fw-bold" htmlFor="bs-validation-classeId">
                        Classe <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Select
                        className="select2 form-select form-select-md"
                        name="classeId"
                        id="bs-validation-classeId"
                        value={editFormData.classeId}
                        onChange={(e) => handleEditChange({ code: e.target.value })}
                        required
                    >
                        {classes.length > 0 && classes.map(item => (
                        <option key={item.code} value={item.code}>{item.name}</option>
                    ))}
                    </Form.Select>
                    {errors.classeId && (
                        <div className="alert alert-danger">{errors.classeId}</div>
                    )}
                </div>

                {/* Sélection de l'Inscription */}
                <div className="col-md-6 mb-3">
                    <Form.Label className="form-label fw-bold" htmlFor="bs-validation-inscriptionId">
                        Inscription <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Select
                        className="select2 form-select form-select-md"
                        name="inscriptionId"
                        id="bs-validation-inscriptionId"
                        value={editFormData.inscriptionId}
                        onChange={handleEditChange}
                        required
                        disabled
                    >
                        <option value="">
                            {selectedInscrit.code_recu}  {/* Affichez le nom et le prénom */}
                        </option>
                    </Form.Select>
                    {errors.inscriptionId && (
                        <div className="alert alert-danger">{errors.inscriptionId}</div>
                    )}
                </div>

                <div className="col-md-6 mb-3">
                    <Form.Label className="form-label fw-bold" htmlFor="bs-validation-classeoptionId">
                        Classe Option <i className="text-danger">*</i>
                    </Form.Label>
                    <Form.Select
                        className="select2 form-select form-select-md"
                        name="classeoptionId"
                        id="bs-validation-classeoptionId"
                        value={editFormData.classeoptionId}
                        onChange={(e) => onChangeClasseOption({ code: e.target.value })}
                        required

                    >
                       {classeoptions.length > 0 && classeoptions.map(item => (
                        <option key={item.code} value={item.code}>{item.name}</option>
                    ))}
                    </Form.Select>
                    {errors.classeoptionId && (
                        <div className="alert alert-danger">{errors.classeoptionId}</div>
                    )}
                </div>
            </div>

            {/* Modal Footer avec les Boutons */}
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setEditModal(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );


    useEffect(() => {
        fetchApprenants();
        fetchClasses();
        fetchClassesoptions();
        fetchPersonnes();
        fetchInscrits();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
           
            navigate(myroutes.login)
        }
    }, [dispatch], [])

    useEffect(() => {
        if (editFormData.classeId) {
            setClasseOptions([]); 
            fetchClassesoptions(editFormData.classeId);
        }
    }, [editFormData.classeId]);

    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">

                <Filarial activeLink={activeLink} />

                {/* Responsive Datatable */}
                <div className="card shadow-lg mb-4 mt-2">
                    <h5 className="card-header">Liste des apprenants &nbsp; &nbsp; &nbsp;
                        <Link to={myroutes.inscription_create} className="btn btn-warning btn-sm" title="Ajouter">
                            <FontAwesomeIcon icon="fa-solid fa-circle-plus" />
                        </Link>
                    </h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">#</th>
                                    <th className="cell text-white">Matricule</th>
                                    <th className="cell text-white">Nom et prénoms</th>
                                    <th className="cell text-white">Classe option</th>
                                    <th className="cell text-white">Type inscription</th>
                                    <th className="cell text-white">Date modification</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {apprenants.length > 0 ? (
                                    apprenants.map((item) => (
                                        <tr key={item.id}> {/* Utiliser item.id comme clé */}
                                            <td className="cell">{apprenants.indexOf(item) + 1}</td> {/* Affichage dynamique des index */}
                                            <td className="cell">{item.matriculeApprenant}</td>
                                            <td>{`${item.personnes?.nomPersonne || ''} ${item.personnes?.prenomsPersonne || ''}`}</td>
                                            <td>{item.classesoptions?.libelleClasseOption || 'N/A'}</td>
                                            <td>
                                                <span className="fw-bold">{item.inscriptions?.typesinscriptions?.libelleTypeInscription || 'N/A'}</span>
                                            </td>
                                            <td className="cell">
                                                <span>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</span>
                                            </td>
                                            <td className="cell">
                                                <Button onClick={() => lauchEdit(item.id)} className="btn btn-sm" style={{ color: "white" }} title="Modifier">
                                                    <i className="fas fa-edit"></i>
                                                </Button> &nbsp; &nbsp;
                                                <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)} title="Supprimer">
                                                    <i className="fas fa-trash"></i>
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">Aucun apprenant trouvé</td> {/* Message si aucune donnée */}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/*/ Responsive Datatable */}
            </div>

            {/**End Modal Edition des apprenants*/}
            <CustomEditModal
                modalTitle="Modification classe"
                modalContent={editModalContent}
                visible={editModal}
                close={() => setEditModal(false)}
            />

        </Layout>
    )
}